module.exports = __webpack_public_path__ + "static/media/cert_155.5e714e33.jpg";